export default __webpack_public_path__ + "static/media/userSuspended.22ac99f6.svg";